import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-imprevu',
  templateUrl: './imprevu.component.html',
  styleUrls: ['./imprevu.component.css']
})
export class ImprevuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
